import { faker } from '@faker-js/faker';

import type { GetUserObjectGetResponse } from '../types/GetUserObjectGetResponse';

export function createGetUserObjectGetResponse(
  data: NonNullable<Partial<GetUserObjectGetResponse>> = {}
): NonNullable<GetUserObjectGetResponse> {
  return {
    ...{
      data: {},
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
